import { useContext } from 'react';
import { ToastCtx } from './_barrel.js';

        const useToast = () => useContext(ToastCtx);

export { useToast };
